module.exports = __webpack_public_path__ + "static/media/wink-desktop-screens.dcbf38c3.png";